import { ref, readonly } from 'vue'

// Create a singleton instance for the chat export popover state
const isOpen = ref(false)
const attachToCase = ref(true)
const isGeneratingPdf = ref(false)
const messageUuid = ref<string | null>(null)

/**
 * Composable for managing the chat export popover state across different views
 * This ensures the popover state persists when navigating between tabs
 */
export function useChatExportPopover() {
  const openPopover = () => {
    isOpen.value = true
  }

  const closePopover = () => {
    isOpen.value = false
    // Reset the messageUuid when the popover is closed to avoid state persistence issues
    messageUuid.value = null
  }

  const setAttachToCase = (value: boolean) => {
    attachToCase.value = value
  }

  const setIsGeneratingPdf = (value: boolean) => {
    isGeneratingPdf.value = value
  }

  const setMessageUuid = (value: string | null) => {
    messageUuid.value = value
  }

  /**
   * Opens the popover for a specific message or for the entire chat
   * @param uuid Optional message UUID. If provided, exports just that message. If null, exports the entire chat.
   */
  const openPopoverForMessage = (uuid: string | null = null) => {
    console.log('Opening popover for message:', uuid)
    messageUuid.value = uuid
    isOpen.value = true
  }

  return {
    // State
    isOpen: readonly(isOpen),
    attachToCase: readonly(attachToCase),
    isGeneratingPdf: readonly(isGeneratingPdf),
    messageUuid: readonly(messageUuid),

    // Methods
    openPopover,
    closePopover,
    setAttachToCase,
    setIsGeneratingPdf,
    setMessageUuid,
    openPopoverForMessage
  }
}
